__turbopack_context__.v({
  "body": "project-filter-module-scss-module__2SRNDq__body",
  "divider": "project-filter-module-scss-module__2SRNDq__divider",
  "maintainer": "project-filter-module-scss-module__2SRNDq__maintainer",
  "raisingFund": "project-filter-module-scss-module__2SRNDq__raisingFund",
  "raisingFundTitle": "project-filter-module-scss-module__2SRNDq__raisingFundTitle",
  "raisingFundWrapper": "project-filter-module-scss-module__2SRNDq__raisingFundWrapper",
});
